import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { XCircleIcon, ArrowLeftIcon, CreditCardIcon } from '@heroicons/react/24/outline';

const PayPalCancel: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [params, setParams] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    // Alle URL-Parameter sammeln
    const allParams: { [key: string]: string } = {};
    searchParams.forEach((value, key) => {
      allParams[key] = value;
    });
    setParams(allParams);
  }, [searchParams]);

  return (
    <div className="max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center gap-3">
          <XCircleIcon className="h-8 w-8 text-error-600" />
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              PayPal-Zahlung abgebrochen
            </h1>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Die Zahlung wurde nicht abgeschlossen
            </p>
          </div>
        </div>
      </div>

      {/* Cancel Message */}
      <div className="bg-error-50 dark:bg-error-900/20 border border-error-200 dark:border-error-800 rounded-xl p-6 mb-6">
        <div className="flex items-center gap-3 mb-4">
          <XCircleIcon className="h-6 w-6 text-error-600 dark:text-error-400" />
          <p className="text-error-700 dark:text-error-300 font-semibold">
            Zahlung wurde abgebrochen
          </p>
        </div>
        <p className="text-sm text-error-600 dark:text-error-400 mb-2">
          Sie haben die Zahlung bei PayPal abgebrochen. Es wurde kein Betrag abgebucht.
        </p>
        <p className="text-sm text-error-600 dark:text-error-400">
          Sie können die Zahlung jederzeit erneut durchführen oder alternativ in Bar beim Kassenwart bezahlen.
        </p>
      </div>

      {/* PayPal Response Data */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 mb-6">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          PayPal-Rückgabedaten
        </h2>

        {Object.keys(params).length === 0 ? (
          <div className="text-center py-8">
            <p className="text-gray-600 dark:text-gray-400">
              Keine PayPal-Parameter empfangen.
            </p>
          </div>
        ) : (
          <div className="space-y-2">
            {Object.entries(params).map(([key, value]) => (
              <div
                key={key}
                className="flex items-start gap-4 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg"
              >
                <span className="text-sm font-medium text-gray-600 dark:text-gray-400 min-w-[150px]">
                  {key}:
                </span>
                <span className="text-sm text-gray-900 dark:text-white break-all">
                  {value}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-3">
        <button
          onClick={() => navigate('/my-drinks')}
          className="flex items-center justify-center gap-2 px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
        >
          <ArrowLeftIcon className="h-5 w-5" />
          Zurück zu meinen Verzehrkosten
        </button>
        <button
          onClick={() => navigate('/my-drinks')}
          className="flex items-center justify-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
        >
          <CreditCardIcon className="h-5 w-5" />
          Erneut versuchen
        </button>
      </div>
    </div>
  );
};

export default PayPalCancel;
